//export const BASE_URL = "http://192.168.8.190/acc_membership/public/api/app";
export const BASE_URL = "https://anagkazo.firstlovegallery.com/api";
//export const BASE_URL = "http://192.168.8.190/acc_membership/public/api";
//export const BASE_URL = "http://192.168.8.125/acc_membership/public/api";
